/**
 * Returns a tuple with all field and field array stores of a form.
 *
 * @param form The form of the stores.
 *
 * @returns The store tuple.
 */
export function getFieldAndArrayStores(form) {
    return [
        ...Object.values(form.internal.fields),
        ...Object.values(form.internal.fieldArrays),
    ];
}
